/* @flow */

import { rem } from 'polished';

import { baseFontSize } from '@braindate/ui/lib/token/typography';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  'label:not(.MuiFormControlLabel-root)': {
    margin: [rem(28, baseFontSize), 0, rem(8, baseFontSize)],
    display: 'block',
    color: ({ theme }: ThemeFunction) => theme.accentColor,
    // Hide highlight occuring when the label is being tapped on WebKit
    WebkitTapHighlightColor: 'transparent',

    fontSize: rem(16, baseFontSize),
    fontWeight: 600,
  },
};
